<button type="button" class="serial-csv-upload" (click)="fileInput.click()" data-testId="serial-csv-upload">
  <mat-icon fontSet="material-symbols-outlined">upload_file</mat-icon>
  <span>Upload CSV</span>
</button>
<input #fileInput type="file" accept=".csv,.txt,text/csv,text/plain" hidden (change)="onFileSelected(fileInput)">

<button
  mat-icon-button
  type="button"
  class="serial-csv-example"
  matTooltip="Download an example CSV"
  aria-label="Download an example CSV"
  (click)="downloadExample()"
  data-testId="serial-csv-example">
  <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
</button>
